module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "kbx-title",
    style: (_vm.stepStyle('welcome-title')),
    attrs: {
      "klickbox-edit-item": "welcome-title",
      "klickbox-edit-label": _vm.$t('edit.canvas.welcome_title')
    }
  }, [_c('text-editor', {
    attrs: {
      "content": _vm.stepPreview.title,
      "change": _vm.onChange,
      "toolbar": true,
      "placeholder": _vm.$t('edit.canvas.welcome_title')
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-779f2068!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/welcome/Title.vue
 ** module id = 866
 ** module chunks = 1
 **/